// packages import
import { Box } from '@mui/material'
import { ThreeCircles } from 'react-loader-spinner'
// others
import palette from '../../theme/palette'

export const OverlayLoader = () => (
  <Box
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
      backdropFilter: 'blur(2px)'
    }}
  >
    <ThreeCircles
      height={80}
      width={80}
      color={palette.primary.main}
      visible={true}
      ariaLabel="three-circles-rotating"
    />
  </Box>
)
